"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecmaVersion = void 0;
exports.ecmaVersion = 11;
